module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Bold.f6fba229.woff";